import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

function AddRing(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2"
        fill="transparent"
      />
      <path
        d="M12 15L12 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M15 12L9 12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </SvgIcon>
  );
}

export default AddRing;
